
import React from 'react';
import { Play } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SpotifyTrack } from '@/types';

interface TrackPreviewCompactProps {
  track: SpotifyTrack;
}

const TrackPreviewCompact: React.FC<TrackPreviewCompactProps> = ({ track }) => {
  return (
    <div className="flex items-center gap-3">
      <div className="relative overflow-hidden rounded-md h-10 w-10 flex-shrink-0">
        <div className="absolute inset-0 flex items-center justify-center bg-black/50">
          <span className="text-xs text-white/70">N/A</span>
        </div>
        
        {/* Play button overlay */}
        <div className="absolute inset-0 flex items-center justify-center bg-black/50 hover:bg-black/70 transition-colors">
          <Button 
            variant="ghost" 
            size="icon"
            className="rounded-full bg-white/10 hover:bg-white/20 text-white h-6 w-6 p-0"
            disabled
          >
            <Play className="h-3 w-3" />
          </Button>
        </div>
      </div>
      
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-white line-clamp-1">
          {track.name}
        </div>
        <div className="text-xs text-white/70 line-clamp-1">
          {track.artists?.join(', ') || 'Unknown Artist'}
        </div>
      </div>
    </div>
  );
};

export default TrackPreviewCompact;
